import { z } from "zod"

// Define the schema for the Series object
export const seriesSchema = z.object({
  /** All the series measures (below) for
   * this series have this identifier. It is
   * a unique integer within the response.
   * You should not assume the integer will be
   * the same for the same series between responses.
   * Instead look at the series’ period, duration,
   * and scenario fields to find the seriesId you need. */
  seriesId: z.number(),
  /** The start date of the series. */
  fromDateTime: z.string(),
  /** The end date of the series. */
  toDateTime: z.string(),
  /** Mathematical formula of scenarios that produced this series. */
  scenario: z.string(),
  /** The display label for this series. */
  displayLabel: z.string(),
  /** The series period/term. Possible values are:
   * "YEAR", "MONTH", "DAY", and "HOUR". */
  seriesPeriod: z.string(),
  /** The duration of the series with respect
   * to the seriesPeriod. e.g. if this is 20 and
   * seriesPeriod is "YEAR", this series’ data
   * covers 20 years. */
  seriesDuration: z.number(),
  /** Not populated for Account Analysis. */
  designId: z.string().nullable(),
  /** For future use. */
  key: z.string().nullable(),
  /** Average rate over the entire duration of this series. */
  rate: z.number().optional().nullable(),
  /** Total quantity over the entire duration of this series. */
  qty: z.number(),
  /** Total cost over the entire duration of this series. */
  cost: z.number(),
})

// Exported type for the Series object
export type Series = z.infer<typeof seriesSchema>
